import React from 'react';

const ListCard = ({ data }) => {
	const renderDetails = () => {
		return Object.entries(data)?.map(([key, v]) => {
			return (
				<div className='flex mt-1  text-sm md:text-base' key={key}>
					<p className='w-2/4 text-black text-left'>{key}</p>
					<p className='w-1/4 text-black text-center'>:</p>
					<p className='w-2/4 text-black font-bold text-right'>{v}</p>
				</div>
			);
		});
	};

	return <div className='m-4 p-2 '>{renderDetails()}</div>;
};

export default ListCard;
